import { FC } from 'react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import RaaTextAreaField from 'components/fieldComponents/raaTextAreaField/RaaTextAreaField';

const ReferenserSection: FC = () => {
  return (
    <DrawerSection>
      <fieldset>
        <legend className="tw-heading-md tw-mb-4">Referenser</legend>
        <RaaTextAreaField
          label="Ange referenser åtskilda med radbrytning"
          classString="raa-textarea tw-h-5"
          name="referenser"
        />
      </fieldset>
    </DrawerSection>
  );
};

export default ReferenserSection;
